import React from "react";
import Select, { MultiValue, StylesConfig } from "react-select";

// 👇 Define the option type
export type OptionType = {
  value: string;
  label: string;
};

interface Props {
  label: string;
  options: OptionType[];
  value: OptionType[];
  onChange: (value: OptionType[]) => void;
  disabled?: boolean; // ✅ Added optional disabled prop
}

const MultiFilter: React.FC<Props> = ({ label, options, value, onChange, disabled }) => {
  return (
    <div className="min-w-[200px] mb-4">
      <label className="block text-sm font-semibold text-gray-600 mb-1">{label}</label>
      <Select
        options={options}
        isMulti
        value={value}
        onChange={(selected: MultiValue<OptionType>) =>
          onChange(selected as OptionType[])
        }
        isDisabled={disabled} // ✅ Apply disabled logic here
        className="text-sm"
        classNamePrefix="react-select"
        styles={{
          control: (base) => ({
            ...base,
            minHeight: "38px",
            border: "none",
            boxShadow: "none",
            "&:hover": {
              border: "none",
            },
          }),
        }}


      />
    </div>
  );
};

export default MultiFilter;
